const config = {
    development: {
        apiUrl: 'http://localhost:8080',
    },
    production: {
        apiUrl: 'https://yvp3q7xwqd.execute-api.us-east-1.amazonaws.com/prod',
    },
};

export default config[process.env.NODE_ENV || 'development'];